{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/IssuanceDto.schema.json",
  "title": "IssuanceDto",
  "type": "object",
  "properties": {
    "authServers": {
      "description": "Authentication server URL for the issuance process.",
      "type": "array",
      "items": {
        "type": "string"
      }
    },
    "notifyWebhook": {
      "description": "Webhook to send the result of the notification response",
      "allOf": [
        {
          "$ref": "./WebhookConfig.schema.json"
        }
      ]
    },
    "batchSize": {
      "type": "number",
      "description": "Value to determine the amount of credentials that are issued in a batch.\nDefault is 1."
    },
    "dPopRequired": {
      "type": "boolean",
      "description": "Indicates whether DPoP is required for the issuance process. Default value is true."
    },
    "display": {
      "type": "array",
      "items": {
        "$ref": "./DisplayInfo.schema.json"
      }
    }
  },
  "required": [
    "display"
  ]
}